@if (!nested && allowEditing && showEditLayoutButton) {
    <div adaptToolbarContent
         alignment="right"
         [ordinal]="-1">
        <button adaptButtonIcon="move"
                [adaptButtonToggle]="isEditing"
                (adaptButtonToggleChange)="toggleEditing($event).subscribe()"
                data-test="layout-edit-button">Edit layout</button>
    </div>
}

@if (allowEditing && !nested) {
    <adapt-layout-manager-controls [layoutManager]="this"> </adapt-layout-manager-controls>
}

@if (!isLayoutVisible) {
    <adapt-loading-spinner class="layout-loading-spinner"
                           [largeSpinner]="true"></adapt-loading-spinner>
}

<div [ngClass]="hostClasses"
     [class]="innerClass"
     [class.layout-initialising]="!isLayoutVisible">
    <ng-content></ng-content>

    @for (size of dynamicColumns; track size) {
        <adapt-layout-column [class]="size"
                             [ngClass]="dynamicColumnClass"></adapt-layout-column>
    }
</div>
